import { MdTrendingUp } from 'react-icons/md';
import { Resources } from '../resource';
import { MainPage } from './main-page';

export const name = Resources.boldPredictionCampaignConfigs;

export const list = MainPage;

export const icon = MdTrendingUp;

export const options = { label: 'module.boldPredictionCampaign.title' };
